module.exports = __webpack_public_path__ + "static/media/parallax-2.32fcf20e.jpg";